import { z } from "zod";
import { isLikelyBase64 } from "@common/validators/is-likely-base64";

export const uploadFinancialDocumentBodySchema = z.object({
    workspaceId: z.string().uuid(),
    file: z.string().refine(isLikelyBase64, {
        message: "file must be a valid base64 string",
    }),
    filename: z.string(),
    contentType: z.string(),
    importerQueue: z.string().optional(),
    reconciliedFinancialAccountId: z.number().int().optional(),
});
